import { useState, useEffect } from "react";
import CustomButton from "../CustomButton";
import CustomInput from "../CustomInput";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import { PaymentCycle } from "../../types/feesAndPaymentType";

interface RecurringSettings {
  paymentCycle: PaymentCycle;
  recurringFrom: string;
  recurringTo: string;
  occurrences: number;
}

interface Props {
  onClose?: () => void;
  onSave: (settings: RecurringSettings) => void;
  initialSettings?: RecurringSettings;
}

export default function RecurringInvoice({ onClose, onSave, initialSettings }: Props) {
  const [paymentCycle, setPaymentCycle] = useState<PaymentCycle>(
    initialSettings?.paymentCycle || "MONTHLY"
  );
  const [recurringFrom, setRecurringFrom] = useState(
    initialSettings?.recurringFrom || ""
  );
  const [recurringTo, setRecurringTo] = useState(
    initialSettings?.recurringTo || ""
  );
  const [occurrences, setOccurrences] = useState(
    initialSettings?.occurrences || 0
  );

  const handleSave = () => {
    onSave({
      paymentCycle,
      recurringFrom,
      recurringTo,
      occurrences,
    });
  };

  return (
    <ModalLayout onClose={onClose} width="max-w-xl">
      <div className="flex flex-col gap-6">
        <h4 className="text-xl font-semibold text-neutral-400">
          Custom recurrence
        </h4>
        <form className="flex flex-col gap-4" onSubmit={(e) => e.preventDefault()}>
          <div className="grid md:grid-cols-2 gap-5">
            <CustomSelect
              name="paymentCycle"
              value={paymentCycle}
              options={["MONTHLY", "YEARLY", "ONE_TIME"]}
              onChange={(e) => setPaymentCycle(e.target.value as PaymentCycle)}
              label="Payment Cycle"
            />
            <CustomInput
              name="recurringFrom"
              value={recurringFrom}
              type="date"
              onChange={(e) => setRecurringFrom(e.target.value)}
              label="Recurring starts On"
            />
            <CustomInput
              name="occurrences"
              value={occurrences.toString()}
              onChange={(e) => setOccurrences(parseInt(e.target.value) || 0)}
              placeholder="Enter Occurrences"
              label="Occurrences"
              type="number"
              min="0"
            />
            <CustomInput
              name="recurringTo"
              value={recurringTo}
              type="date"
              onChange={(e) => setRecurringTo(e.target.value)}
              label="Recurring End On"
            />
          </div>
        </form>
        <div className="flex justify-end items-end gap-4">
          <CustomButton text="Close" color="bg-neutral-200" onClick={onClose} />
          <CustomButton 
            text="Save" 
            color="bg-primary-500" 
            onClick={handleSave}
          />
        </div>
      </div>
    </ModalLayout>
  );
}